/* eslint-disable */
import React, { useEffect, useState } from "react";
import { getResponsiveImage } from "../../utils/imageHelper";


interface BannerGeneralComponentProps {
  title: any;
  banner: any;
}

const BannerGeneralComponent: React.FC<BannerGeneralComponentProps> = ({ title, banner }) => {
  const [isPortrait, setIsPortrait] = useState<boolean>(false);

  useEffect(() => {
    const mediaQuery = window.matchMedia("(orientation: portrait)");

    const handleOrientationChange = (e: MediaQueryListEvent | MediaQueryList) => {
      setIsPortrait(e.matches);
    };

    handleOrientationChange(mediaQuery);
    mediaQuery.addEventListener("change", handleOrientationChange);

    return () => {
      mediaQuery.removeEventListener("change", handleOrientationChange);
    };
  }, []);

  const backgroundUrl = isPortrait
    ? getResponsiveImage(banner?.media_portrait?.url || '').desktop
    : getResponsiveImage(banner?.media?.url || '').desktop;


  return (
    <div
      className="banner-posventa-component"
      style={{ backgroundImage: `url(${backgroundUrl})` }}
    >
      {/* H1 - Título principal del banner */}
      <h1 className="text1-banner-posventa-component">{banner?.title}</h1>
    </div>
  );
};

export default BannerGeneralComponent;